import { observable, action, computed, toJS, makeObservable } from 'mobx'
import { superAxiosRequest } from 'axiosApi'
import { checkPermList } from 'helpers'
import { permissions } from 'settings/permissions'

class ProductionCalendarStore {
  apiConf = {
    link: 'employees/production_calendar',
    params: {
      limit: 9999,
    },
  }
  prodCalendarData = []
  year = new Date().getFullYear()

  constructor() {
    makeObservable(this, {
      prodCalendarData: observable,
      year: observable,

      setYear: action,
      addHoliday: action,
      removeHoliday: action,
      prodCalendarDay: computed,
    })
  }

  fetchProdCalendarDay = () => {
    superAxiosRequest({
      method: 'get',
      ...this.apiConf,
    })
      .then(this.setProdCalendarDay)
      .catch(() => {})
  }

  updateDate = (day) => {
    const request = day.selected
      ? this.deleteDate(day.full_date, day.id)
      : this.addDate(day.full_date)
    request
      .then((response) => {
        if (day.selected) {
          this.removeHoliday(day.id)
        } else {
          this.addHoliday(response.data)
        }
      })
      .catch(() => {})
  }

  addDate = (date) =>
    superAxiosRequest(
      {
        method: 'post',
        ...this.apiConf,
      },
      {
        date,
      },
    )

  deleteDate = (date, id) => {
    const hasPermission = checkPermList(permissions.delete_production_calendar)
    if (hasPermission) {
      return superAxiosRequest({
        method: 'delete',
        link: `${this.apiConf.link}/${id}`,
      })
        .then((response) => {
          return response
        })
        .catch((error) => {
          throw error
        })
    }
  }
  setProdCalendarDay = (res) => (this.prodCalendarData = res.data.result)

  addHoliday = (holiday) => {
    this.prodCalendarData.push(holiday)
  }

  removeHoliday = (holiday) => {
    this.prodCalendarData = this.prodCalendarData.filter(
      (x) => x.id !== holiday,
    )
  }

  setYear = (year) => (this.year = year)

  get prodCalendarDay() {
    return toJS(this.prodCalendarData)
  }
}

export default new ProductionCalendarStore()
